import React, {PureComponent} from 'react';
import {Form, Icon, Input,Descriptions } from 'antd';
import {RTLCol} from '../RTLKit';


export default class TextField extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        const {
            label,
            description
        } = this.props;

        return (
            <RTLCol span={24} className="descriptionWrapper">
                <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                    {label ? <label>{label} : </label> : null}
                </RTLCol>
                <RTLCol md={label ? 15 : 19} sm={24} className="descriptionBox">
                    {description}
                </RTLCol>
            </RTLCol>
        );
    }
}



